import { render, staticRenderFns } from "./Zhuanti.vue?vue&type=template&id=3abb9834&"
import script from "./Zhuanti.vue?vue&type=script&lang=js&"
export * from "./Zhuanti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports